module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "title": "数据操作",
      "size": "large"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-b-10"
  }, [_c('el-button', {
    staticClass: "fl m-r-20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCudConfig
    }
  }, [_vm._v("添加操作")]), _vm._v(" "), _c('div', {
    staticClass: "fl form-tips lh-20",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("日期变量说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，H+1代表一个小时后，I+10代表十分钟后，S+30代表30秒后")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-list bor-deep-gra ovf-auto m-b-10",
    staticStyle: {
      "height": "500px"
    }
  }, [_vm._l((_vm.childCudConfig), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "bor-b-gray m-b-10"
    }, [_c('div', {
      staticClass: "inline-block m-r-10 m-b-10"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "disabled": index == 0
      },
      on: {
        "click": function($event) {
          _vm.sortUp(index)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small",
        "disabled": index == _vm.childCudConfig.length - 1
      },
      on: {
        "click": function($event) {
          _vm.sortDown(index)
        }
      }
    }, [_vm._v("下移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteCudConfig(index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
      staticClass: " inline-block m-l-20"
    }, [_c('span', [_vm._v("操作类型")]), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.deal_type),
        expression: "item.deal_type"
      }],
      attrs: {
        "placeholder": "请选择操作类型"
      },
      domProps: {
        "value": (item.deal_type)
      },
      on: {
        "change": function($event) {
          _vm.dealTypeChange(item)
        },
        "input": function($event) {
          item.deal_type = $event
        }
      }
    }, _vm._l((_vm.dealTypeOptions), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name,
          "value": option.id
        }
      })
    }))])]), _vm._v(" "), (_vm.showFuncSelect(item)) ? _c('div', {
      staticClass: "m-b-10"
    }, [_c('div', [_c('span', [_vm._v("函数库")]), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.function_name),
        expression: "item.function_name"
      }],
      attrs: {
        "placeholder": "请选择函数库"
      },
      domProps: {
        "value": (item.function_name)
      },
      on: {
        "change": function($event) {
          _vm.funcChange(item, index)
        },
        "input": function($event) {
          item.function_name = $event
        }
      }
    }, _vm._l((_vm.functions), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.title,
          "value": option.name
        }
      })
    }))])]) : _vm._e(), _vm._v(" "), (_vm.showTargetForm(item)) ? _c('div', {
      staticClass: "m-b-10"
    }, [_c('div', [_c('span', [_vm._v("模板表单")]), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.template_model_id),
        expression: "item.template_model_id"
      }],
      attrs: {
        "placeholder": "请选择操作表单"
      },
      domProps: {
        "value": (item.template_model_id)
      },
      on: {
        "change": function($event) {
          _vm.templateModelChange(item)
        },
        "input": function($event) {
          item.template_model_id = $event
        }
      }
    }, _vm._l((_vm.models), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.title + '(' + option.name + ')',
          "value": option.id
        }
      })
    }))])]) : _vm._e(), _vm._v(" "), (!_vm.showFuncSelect(item)) ? _c('div', {
      staticClass: "m-b-10"
    }, [_c('div', [(_vm.showTargetForm(item)) ? _c('span', [_vm._v("目标表单")]) : _c('span', [_vm._v("操作表单")]), _vm._v(" "), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.model_id),
        expression: "item.model_id"
      }],
      attrs: {
        "placeholder": "请选择操作表单"
      },
      domProps: {
        "value": (item.model_id)
      },
      on: {
        "change": function($event) {
          _vm.modelChange(item, index)
        },
        "input": function($event) {
          item.model_id = $event
        }
      }
    }, _vm._l((_vm.models), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.title + '(' + option.name + ')',
          "value": option.id
        }
      })
    }))])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('condition-config', {
      attrs: {
        "currentItem": item,
        "loadings": _vm.loadings,
        "currentIndex": index,
        "logicOptions": _vm.logicOptions,
        "paramTypeOptions": _vm.paramTypeOptions,
        "fieldByModelId": _vm.fieldByModelId,
        "flowFormField": _vm.flowFormField,
        "currentType": _vm.CUD_LIST_PROEXEC
      }
    }), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.showWhereList(item)) ? _c('div', [_c('condition-config', {
      attrs: {
        "currentItem": item,
        "loadings": _vm.loadings,
        "currentIndex": index,
        "logicOptions": _vm.logicOptions,
        "paramTypeOptions": _vm.paramTypeOptions,
        "fieldByModelId": _vm.fieldByModelId,
        "flowFormField": _vm.flowFormField,
        "currentType": _vm.CUD_LIST_WHERE
      }
    })]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.showFieldList(item)) ? _c('div', {
      staticClass: "m-b-10"
    }, [(_vm.typeCopy(item)) ? _c('div', [_vm._v("目标数据")]) : _c('div', [_vm._v("更新内容")]), _vm._v(" "), _vm._v(" "), _c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loadings[index]),
        expression: "loadings[index]"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": item.field
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "传入类型",
        "width": "250"
      },
      scopedSlots: {
        default: function(scope) {
          return [_c('el-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.param_type),
              expression: "scope.row.param_type"
            }],
            staticClass: "w-200",
            domProps: {
              "value": (scope.row.param_type)
            },
            on: {
              "input": function($event) {
                scope.row.param_type = $event
              }
            }
          }, _vm._l((_vm.paramTypeOptions), function(option, optionIndex) {
            return (_vm.showParamTypeOptions(item.deal_type, optionIndex)) ? _c('el-option', {
              attrs: {
                "label": option.name,
                "value": option.id
              }
            }) : _vm._e()
          }))]
        }
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "传入的字段或参数"
      },
      scopedSlots: {
        default: function(scope) {
          return [(_vm.isText(scope.row)) ? _c('el-input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.param),
              expression: "scope.row.param"
            }],
            staticClass: "w-200",
            domProps: {
              "value": (scope.row.param)
            },
            on: {
              "input": function($event) {
                scope.row.param = $event
              }
            }
          }) : (_vm.isSelect(scope.row) && !_vm.isTemplateForm(scope.row) && item.deal_type != _vm.CUD_DEAL_FUNC) ? _c('el-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.param),
              expression: "scope.row.param"
            }],
            staticClass: "w-200",
            domProps: {
              "value": (scope.row.param)
            },
            on: {
              "input": function($event) {
                scope.row.param = $event
              }
            }
          }, _vm._l((_vm.flowFormField), function(option) {
            return _c('el-option', {
              attrs: {
                "label": option.name + '(' + option.title + ')',
                "value": option.field_id
              }
            })
          })) : (_vm.isSelect(scope.row) && !_vm.isTemplateForm(scope.row) && item.deal_type == _vm.CUD_DEAL_FUNC) ? _c('el-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.param),
              expression: "scope.row.param"
            }],
            staticClass: "w-200",
            domProps: {
              "value": (scope.row.param)
            },
            on: {
              "change": function($event) {
                _vm.getForeignKey(scope.row, scope.$index, index)
              },
              "input": function($event) {
                scope.row.param = $event
              }
            }
          }, _vm._l((_vm.flowFormField), function(option) {
            return _c('el-option', {
              attrs: {
                "label": option.name + '(' + option.title + ')',
                "value": option.field_id
              }
            })
          })) : (_vm.isSelect(scope.row) && _vm.isTemplateForm(scope.row)) ? _c('el-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.param),
              expression: "scope.row.param"
            }],
            staticClass: "w-200",
            domProps: {
              "value": (scope.row.param)
            },
            on: {
              "input": function($event) {
                scope.row.param = $event
              }
            }
          }, _vm._l((_vm.fieldByModelId[item.template_model_id]), function(option) {
            return _c('el-option', {
              attrs: {
                "label": option.name + '(' + option.title + ')',
                "value": option.field_id
              }
            })
          })) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), (scope.row.param_type == _vm.CUD_PARAM_CUMULATIVE_VARIABLE) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (scope.row.param_type == _vm.CUD_PARAM_CUMULATIVE_VARIABLE) ? _c('el-input', {
            directives: [{
              name: "model",
              rawName: "v-model.number",
              value: (scope.row.coefficient),
              expression: "scope.row.coefficient",
              modifiers: {
                "number": true
              }
            }],
            staticClass: "w-200",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (scope.row.coefficient)
            },
            on: {
              "input": function($event) {
                scope.row.coefficient = _vm._n($event)
              },
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          }) : _vm._e()]
        }
      }
    }), _vm._v(" "), (item.deal_type == _vm.CUD_DEAL_FUNC) ? _c('el-table-column', {
      attrs: {
        "label": "外键关联表的字段"
      },
      scopedSlots: {
        default: function(scope) {
          return [(scope.row.foreign_key_list && scope.row.foreign_key_list.length > 0) ? _c('el-cascader', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.form_key_sign),
              expression: "scope.row.form_key_sign"
            }],
            attrs: {
              "placeholder": "外键关联字段",
              "options": scope.row.foreign_key_list,
              "filterable": "",
              "change-on-select": ""
            },
            domProps: {
              "value": (scope.row.form_key_sign)
            },
            on: {
              "change": _vm.changeForeign,
              "input": function($event) {
                scope.row.form_key_sign = $event
              }
            }
          }) : _c('el-input', {
            staticClass: "w-200",
            attrs: {
              "disabled": true
            }
          }), _vm._v(" ")]
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "对应字段"
      },
      scopedSlots: {
        default: function(scope) {
          return [(_vm.fieldByModelId[item.model_id] &&
            _vm.fieldByModelId[item.model_id][scope.$index] &&
            (item.deal_type == _vm.CUD_DEAL_ADD || item.deal_type == _vm.CUD_DEAL_COPY)) ? _c('span', {
            staticClass: "fz-12",
            class: {
              'form-tips': _vm.fieldByModelId[item.model_id] &&
                _vm.fieldByModelId[item.model_id][scope.$index] &&
                _vm.fieldByModelId[item.model_id][scope.$index].is_needed == 1
            }
          }, [_vm._v("\n                    " + _vm._s(_vm.fieldByModelId[item.model_id][scope.$index].name) + "(" + _vm._s(_vm.fieldByModelId[item.model_id][scope.$index].title) + ")\n              ")]) : _vm._e(), _vm._v(" "), (item.deal_type == _vm.CUD_DEAL_FUNC) ? _c('span', [_vm._v("\n                " + _vm._s(scope.row.field_id) + "\n              ")]) : _vm._e(), _vm._v(" "), (item.deal_type == _vm.CUD_DEAL_UPDATE || item.deal_type == _vm.CUD_DEAL_DELETE) ? _c('el-select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (scope.row.field_id),
              expression: "scope.row.field_id"
            }],
            domProps: {
              "value": (scope.row.field_id)
            },
            on: {
              "input": function($event) {
                scope.row.field_id = $event
              }
            }
          }, _vm._l((_vm.fieldByModelId[item.model_id]), function(option) {
            return _c('el-option', {
              attrs: {
                "label": option.name + '(' + option.title + ')',
                "value": option.field_id
              }
            })
          })) : _vm._e()]
        }
      }
    }), _vm._v(" "), (item.deal_type == _vm.CUD_DEAL_UPDATE || item.deal_type == _vm.CUD_DEAL_DELETE) ? _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "180"
      },
      scopedSlots: {
        default: function(scope) {
          return [_c('el-button', {
            attrs: {
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.deleteField(item.field, scope.$index)
              }
            }
          }, [_vm._v("删除")])]
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.deal_type == _vm.CUD_DEAL_UPDATE || item.deal_type == _vm.CUD_DEAL_DELETE),
        expression: "item.deal_type == CUD_DEAL_UPDATE || item.deal_type == CUD_DEAL_DELETE"
      }],
      staticClass: "tx-c m-t-10"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addField(item.field, 'field')
        }
      }
    }, [_vm._v("添加")])])]) : _vm._e(), _vm._v(" ")])
  }), _vm._v(" ")], true), _vm._v(" "), _c('span', {
    staticClass: "fl dialog-footer m-b-10",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存所有修改")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c1323b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/cudConfig.vue
// module id = 1936
// module chunks = 2